<app-oncall-home></app-oncall-home>
@if (pageEnabled) {
  <div style="display: flex; flex-direction: column; align-items: center;">
    <p class="members-header">Members</p>
    <div style="font-weight: bold; display: flex; align-items: center; padding: 0;">
      <label for="search">
        Search:
      </label>
      <div style="padding-left:5px">
        <input id="search" type="text" [(ngModel)]="searchTerm" (ngModelChange)="applySearchFilter()">
      </div>
    </div>
    <div>
      <table matSort class="mat-elevation-z8" #membersTable mat-table [dataSource]="dataSource" multiTemplateDataRows
        aria-describedby="members">
        @for (column of columns; track column) {
          <ng-container [matColumnDef]="column.columnDef">
            <th mat-header-cell class="header-row" *matHeaderCellDef mat-sort-header>
            {{ column.header }}</th>
            <td mat-cell *matCellDef="let member">
              <ng-container>
                {{ column.cell(member) }}
              </ng-container>
            </td>
          </ng-container>
        }
        <ng-container matColumnDef="action">
          <th mat-header-cell class="header-row" *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let member">
            <button mat-icon-button class="material-icons app-toolbar-menu save-button" matTooltip="Edit"
              color="primary" (click)="openTeamMemberDetailsDialog(member.name, member.email, member.phoneNumber.slice(-10), member.smsNotificationsEnabled,
              member.voiceCallNotificationsEnabled, member.emailNotificationsEnabled)"
              [disabled]="member.email.toLowerCase() != currentUserEmail.toLowerCase() && !isPlatform">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button class="material-icons app-toolbar-menu delete-button" matTooltip="Delete"
              color="warn"
              (click)="confirmAction('Are you sure you want to delete this team member?', deleteTeamMemberDetails, member)"
              [disabled]="!isPlatform">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        <tr #tableRow mat-row *matRowDef="let members; columns: displayedColumns;" style="height: 40px;">
        </tr>
      </table>
    </div>
  </div>
} @else {
  <div>
    <h2>This page has been temporarily disabled by the Platform Team.</h2>
  </div>
}

